/** @jsx jsx */
import { Flex, generateId } from "@eworkit/iris";
import { useState, useMemo, FC, useCallback } from "react";
import { createPortal } from "react-dom";
import { jsx } from "theme-ui";

import { Toast } from "./Toast";
import { ToastsContext } from "./ToastsContext";

export interface ToastData {
  id: string;
  text: string;
  type: "success" | "information" | "warning" | "danger";
}

export interface ToastsProviderProps {}

export const ToastsProvider: FC<ToastsProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<ToastData[]>([]);

  const addToast = useCallback((toast: ToastData) => {
    setToasts((currentToasts: ToastData[]) => [
      ...currentToasts,
      { id: generateId(), text: toast.text, type: toast.type },
    ]);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts((currentToasts: ToastData[]) => currentToasts.filter((toast: ToastData) => toast.id !== id));
  }, []);

  const contextValue = useMemo(
    () => ({
      addToast,
    }),
    [addToast],
  );

  return (
    <ToastsContext.Provider value={contextValue}>
      {children}
      {createPortal(
        <div
          sx={{
            position: "fixed",
            bottom: 24,
            left: 24,
            width: "100%",
            zIndex: 10001,
          }}>
          <Flex gap="sm" flexDirection="column">
            {toasts.map((toast: ToastData) => (
              <Toast key={toast.id} onClose={() => removeToast(toast.id)} {...toast} />
            ))}
          </Flex>
        </div>,
        document.body,
      )}
    </ToastsContext.Provider>
  );
};
